import React, { Suspense, lazy } from 'react'

export default function getIcon(name) {
  const SelectedIcon = icons[name.toLowerCase()]
    ?? lazy(() => import('@material-ui/icons/Warning'));

    return (
    <Suspense fallback="">
      <SelectedIcon />
    </Suspense>
  )
}

const icons = {
  'campaignpageoverview': lazy(() => import('@material-ui/icons/Announcement')),
  'campaignpage': lazy(() => import('@material-ui/icons/Highlight')),
  'feedback': lazy(() => import('@material-ui/icons/Announcement')),
  'exit': lazy(() => import('@material-ui/icons/ExitToApp')),
  'dashboardpage': lazy(() => import('@material-ui/icons/Dashboard')),
  'admin': lazy(() => import('@material-ui/icons/SupervisedUserCircle')),
  'basket': lazy(() => import('@material-ui/icons/ShoppingBasket')),
  'homepage': lazy(() => import('@material-ui/icons/Home')),
  'products': lazy(() => import('@material-ui/icons/Shop')),
  'invoice': lazy(() => import('@material-ui/icons/Wallpaper')),
  'graph': lazy(() => import('@material-ui/icons/GraphicEqOutlined')),
  'gallery': lazy(() => import('@material-ui/icons/PhotoAlbum')),
  'switch': lazy(() => import('@material-ui/icons/SwitchCamera')),
  'search': lazy(() => import('@material-ui/icons/Search')),
  'user': lazy(() => import('@material-ui/icons/AccountCircle')),
  'settings': lazy(() => import('@material-ui/icons/Settings')),
  'quickentry': lazy(() => import('@material-ui/icons/Dialpad')),
  'orders': lazy(() => import('@material-ui/icons/AssignmentLate')),
  'invoices': lazy(() => import('@material-ui/icons/AssignmentTurnedIn')),
  'statistics': lazy(() => import('@material-ui/icons/BarChart')),
  'help': lazy(() => import('@material-ui/icons/Help')),
  'customers': lazy(() => import('@material-ui/icons/People')),
  'translate': lazy(() => import('@material-ui/icons/Translate')),
  'hub': lazy(() => import('@material-ui/icons/Apps')),
  'returnservice': lazy(() => import('@material-ui/icons/RemoveShoppingCart')),
  'productsearch': lazy(() => import('@material-ui/icons/Highlight')),
  'videopage': lazy(() => import('@material-ui/icons/PlayCircleOutline')),
  'basketoverview': lazy(() => import('@material-ui/icons/ShoppingBasket')),
  'translate': lazy(() => import('@material-ui/icons/Translate')),
  'internalproductspage': lazy(() => import('@material-ui/icons/Category')),
};
